import { Head as Helmet } from 'vite-react-ssg';

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  ogImage?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: 'website' | 'product' | 'article';
  twitterCard?: 'summary' | 'summary_large_image';
  noindex?: boolean;
}

export const SEO = ({
  title,
  description,
  keywords,
  canonical,
  ogImage = 'https://systemique.nl/OG-image.jpg',
  ogTitle,
  ogDescription,
  ogType = 'website',
  twitterCard = 'summary_large_image',
  noindex = false,
}: SEOProps) => {
  const canonicalUrl = canonical || (typeof window !== 'undefined' ? `https://systemique.nl${window.location.pathname}` : 'https://systemique.nl');
  const fullTitle = title.includes('Systemique') ? title : `${title} | Systemique`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonicalUrl} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={ogTitle || fullTitle} />
      <meta property="og:description" content={ogDescription || description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Systemique" />
      <meta property="og:locale" content="nl_NL" />

      {/* Twitter Card */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={ogTitle || fullTitle} />
      <meta name="twitter:description" content={ogDescription || description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

